var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-container"},[(_vm.canvasImage)?_c('img',{staticClass:"canvas-image",staticStyle:{"max-width":"100%","height":"auto","image-rendering":"crisp-edges"},attrs:{"src":_vm.canvasImage}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }